module.exports = __webpack_public_path__ + "static/media/team-card.35357561.JPG";